<template>
  <span>
   <span type="border" class="how-dream-looks-like cursor-pointer font-semibold text-dark" @click="open">and so much more+</span>

  <vs-popup class="how-to-create-dream-popup text-dark" title="" :active.sync="popupActive">
    <!-- <h2>own your life</h2> -->
    <div class="px-8">
      <Feature v-for="feature in features" class="mb-4" :feature="feature" :key="feature.name"/>
    </div>

  </vs-popup>
  </span>
 </template>


<script>
import Feature from './Feature'
import trackAnalytics from '@/helpers/trackAnalytics'

export default {
  components: {
    Feature
  },
  props: ['features'],
  data () {
    return {
      popupActive: false
    }
  },
  methods: {
    open () {
      trackAnalytics(this, 'app_action', 'click', 'onboarding-and-so-much-more', this.$store.getters.daysFromRegistration)
      this.popupActive = true
    }
  }
}
</script>


<style scoped>
h2 {
  font-size: 2.5rem;
}

.how-dream-looks-like {
  cursor: pointer;
  margin-top: 2rem;
}

</style>
